import React from "react";
import { redesSociales } from "../config/configuraciones";

function ContactoHome2() {

  return (
    <React.Fragment>

      <section>

        <div className="container-azul223">
        <div className="cab-verde3" >
          <h1 className="h1-1 centrar">Contactanos</h1>
          </div>
          <div className="container-azul3">

              <div className="redes-cont3">
          <a href={redesSociales.instagram} target="_blank" rel="noopener noreferrer">
            <img className="redes-contacto3" src="/fans/ig.png" alt="instagram"/>
          </a>
          <a href={redesSociales.x} target="_blank" rel="noopener noreferrer" aria-label="X">
            <svg
              className="redes-contacto3"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="white"
              style={{margin: '0 10px'}}
            >
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </a>
          <a href={redesSociales.facebook} target="_blank" rel="noopener noreferrer">
            <img className="redes-contacto3" src="/fans/fb.png" alt="facebook" />
          </a>
          <a href={redesSociales.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <svg
              className="redes-contacto3"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="white"
              style={{margin: '0 10px'}}
            >
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
          </a>
          </div>
          </div>
          </div>


      </section>
    </React.Fragment>
  );
}
export default ContactoHome2;
